/** Format naira amounts without dropping kobo. */
export const naira = (amount: number): string =>
  `₦${amount.toLocaleString('en-NG', { maximumFractionDigits: 2, minimumFractionDigits: Number.isInteger(amount) ? 0 : 2 })}`

export const nairaFromMinor = (minor: number): string => naira(minor / 100)
